export default __webpack_public_path__ + "static/media/76-desktop.477eb35d.jpg";